import xmljs from 'xml-js'

export default {
  async fetch ({ commit }, payload) {
    let xmlData = []
    const url = payload.url
    try {
      const response = await this.$axios({ method: 'get', url })
      xmlData = xmljs.xml2js(response.data, { compact: true })
    } catch (error) {}

    return xmlData
  }
}
